/* Hishopy theme — behaviour */
(function () {
  'use strict';

  var HS = window.HS || { strings: {}, root: '/', currency: '' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var n = Number(cents) / 100;
    var s = (n % 1 === 0) ? String(n) : n.toFixed(2);
    return s + ' ' + HS.currency;
  }
  function formatBare(cents) {
    var n = Number(cents) / 100;
    return (n % 1 === 0) ? String(n) : n.toFixed(2);
  }

  /* ---------- announcement rotator ---------- */
  function initRotator(track) {
    var msgs = track.querySelectorAll('.announce__msg');
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0;
    var delay = Number(track.dataset.interval) || 4000;
    setInterval(function () {
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      var next = msgs[i];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      cur.setAttribute('aria-hidden', 'true');
      next.classList.remove('is-leaving');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 600);
    }, delay);
  }

  /* ---------- details-based dropdowns and drawer ---------- */
  function initDropdowns() {
    document.addEventListener('click', function (e) {
      document.querySelectorAll('details.dd[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) {
        var d = closer.closest('details');
        if (d) d.removeAttribute('open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('details.dd[open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });
    document.querySelectorAll('details[data-drawer]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        document.documentElement.style.overflow = d.open ? 'hidden' : '';
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el, idx) {
      el.style.transitionDelay = ((idx % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- keep a headline on one line ---------- */
  function fitText() {
    document.querySelectorAll('[data-fit]').forEach(function (el) {
      var size = Number(el.dataset.fitMax) || 60;
      el.style.fontSize = size + 'px';
      while (el.scrollWidth > el.clientWidth && size > 16) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
    });
  }

  /* ---------- homepage slider ---------- */
  function initSlider(root) {
    var track = root.querySelector('[data-slider-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.hs__slide');
    var dots = root.querySelectorAll('[data-slider-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var delay = (Number(root.dataset.autoplay) || 0) * 1000;
    var timer = null;
    function mark(i) {
      index = i;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        var a = s.querySelector('a');
        if (a) a.tabIndex = n === i ? 0 : -1;
      });
      dots.forEach(function (d, n) {
        if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth });
      mark(i);
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!delay || reduceMotion) return;
      timer = setInterval(function () { if (!document.hidden) go(index + 1); }, delay);
    }
    // in Arabic the "next" arrow is the left one, following the reading direction
    var rtl = document.documentElement.dir === 'rtl';
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { go(index + (rtl ? 1 : -1)); start(); });
    if (next) next.addEventListener('click', function () { go(index + (rtl ? -1 : 1)); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(Number(d.dataset.sliderDot)); start(); });
    });
    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(start, 4000); }, { passive: true });
    root.addEventListener('focusin', stop);
    window.addEventListener('resize', function () { track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' }); });
    start();
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-buy]');
    var idInput = root.querySelector('[data-variant-id]');
    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    // gallery
    var thumbs = root.querySelectorAll('[data-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    function showMedia(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (s) {
        var on = s.dataset.slide === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        if (t.dataset.thumb === String(id)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    // thumbnails: every photo shows until the customer picks a colour herself; then only that colour's photos.
    // A colour's photos start at its variants' featured photo and run until the next colour's.
    var colorInput = root.querySelector('.opt--color [data-option-index]');
    var colorIdx = colorInput ? Number(colorInput.dataset.optionIndex) : -1;
    var colorStart = {};
    if (colorIdx > -1) variants.forEach(function (v) {
      if (!v.featured_media) return;
      var c = v.options[colorIdx];
      var pos = v.featured_media.position;
      if (colorStart[c] === undefined || pos < colorStart[c]) colorStart[c] = pos;
    });
    var starts = Object.keys(colorStart).map(function (c) { return { c: c, p: colorStart[c] }; })
      .sort(function (a, b) { return a.p - b.p; });
    thumbs.forEach(function (t, i) {
      var owner = null;
      starts.forEach(function (s) { if (s.p <= i + 1) owner = s.c; });
      t.dataset.color = owner === null ? '' : owner;
    });
    function filterThumbs(color) {
      if (starts.length < 2) return;
      thumbs.forEach(function (t) { t.hidden = !!t.dataset.color && t.dataset.color !== color; });
    }

    // variants
    var radios = root.querySelectorAll('[data-option-index]');
    function selectedOptions() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[Number(r.dataset.optionIndex)] = r.value; });
      return opts;
    }
    function markAvailability(opts) {
      radios.forEach(function (r) {
        var idx = Number(r.dataset.optionIndex);
        var test = opts.slice();
        test[idx] = r.value;
        var ok = variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return test[i] === undefined || o === test[i]; });
        });
        r.closest('.opt__value').classList.toggle('is-unavailable', !ok);
      });
    }
    function updatePrice(v) {
      root.querySelectorAll('[data-price-wrap]').forEach(function (wrap) {
        var p = wrap.querySelector('[data-price]');
        var c = wrap.querySelector('[data-compare]');
        var b = wrap.querySelector('[data-badge]');
        if (p) p.textContent = formatMoney(v.price);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (c) { c.hidden = !sale; c.textContent = sale ? formatBare(v.compare_at_price) : ''; }
        if (b) { b.hidden = !sale; b.textContent = sale ? '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; }
      });
    }
    function onOptionChange(initial) {
      var opts = selectedOptions();
      radios.forEach(function (r) {
        if (r.checked) {
          var label = root.querySelector('[data-option-label="' + r.dataset.optionIndex + '"]');
          if (label) label.textContent = r.value;
        }
      });
      markAvailability(opts);
      root.querySelectorAll('[data-option-set]').forEach(function (set) {
        if (set.querySelector('input:checked')) showMissing(set, false);
      });
      // colour picked but not the size yet: show that colour's photos and wait
      if (colorIdx > -1 && opts[colorIdx] !== undefined) {
        var byColor = variants.find(function (x) { return x.options[colorIdx] === opts[colorIdx] && x.featured_media; });
        if (byColor) showMedia(byColor.featured_media.id);
        if (initial !== true) filterThumbs(opts[colorIdx]);
      }
      if (missingOptions().length) { updateWhatsapp(); return; }
      root.classList.remove('needs-choice');
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var submits = root.querySelectorAll('[data-buy-submit]');
      var label = root.querySelector('[data-buy-label]');
      if (!v) {
        submits.forEach(function (b) { b.disabled = true; });
        if (label) label.textContent = HS.strings.unavailable;
        return;
      }
      current = v;
      if (idInput) idInput.value = v.id;
      updatePrice(v);
      updateTotal();
      submits.forEach(function (b) { b.disabled = !v.available; });
      if (label) label.textContent = v.available ? (label.dataset.defaultText || label.textContent) : HS.strings.soldOut;
      if (v.featured_media) showMedia(v.featured_media.id);
      if (colorIdx > -1 && initial !== true) filterThumbs(v.options[colorIdx]);
      if (initial !== true && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    var codLabel = root.querySelector('[data-buy-label]');
    if (codLabel && current.available) codLabel.dataset.defaultText = codLabel.textContent;
    radios.forEach(function (r) { r.addEventListener('change', function () { onOptionChange(false); }); });
    if (radios.length) markAvailability(selectedOptions());

    // the customer must pick every option herself before ordering
    function missingOptions() {
      return Array.prototype.filter.call(root.querySelectorAll('[data-option-set]'), function (set) {
        return !set.querySelector('input:checked');
      });
    }
    function showMissing(set, on) {
      set.classList.toggle('is-missing', on);
      var err = set.querySelector('[data-option-error]');
      if (err) err.hidden = !on;
    }
    if (missingOptions().length) root.classList.add('needs-choice');
    function guardOrder(e) {
      var missing = missingOptions();
      if (!missing.length) return;
      var t = e.target;
      var inForm = (t.closest && (t.closest('#_rsi-form-container-embedded, #es-form-container') || t.closest('[data-buy]')));
      if (!inForm || !root.contains(inForm)) return;
      if (e.type === 'click' && !t.closest('.rsi-submit_button, .es-cta-btn, [type="submit"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      missing.forEach(function (set) { showMissing(set, true); });
      missing[0].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
    window.addEventListener('click', guardOrder, true);
    window.addEventListener('submit', guardOrder, true);

    // quantity + total
    var qtyInput = root.querySelector('[data-qty-input]');
    var totalEl = root.querySelector('[data-total]');
    function updateTotal() {
      if (!totalEl || !qtyInput) return;
      var q = Math.max(1, Math.min(10, parseInt(qtyInput.value, 10) || 1));
      totalEl.textContent = formatMoney(current.price * q);
    }
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.qty);
        qtyInput.value = Math.max(1, Math.min(10, q));
        updateTotal();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', updateTotal);
    updateTotal();

    // bundle offers: the chosen card sets the quantity sent to the cart
    // and the quantity inside the Releasit order form
    var qtyHidden = root.querySelector('[data-qty-hidden]');
    var wantQty = 1;
    function syncFormQty() {
      var box = document.getElementById('_rsi-form-container-embedded');
      if (!box) return;
      var input = box.querySelector('.rsi-quantity-input');
      var plus = box.querySelector('.rsi-quantity-increase');
      var minus = box.querySelector('.rsi-quantity-decrease');
      if (!input) return;
      var have = parseInt(input.value, 10) || 1;
      if (have < wantQty && plus && !plus.disabled) plus.click();
      else if (have > wantQty && minus && !minus.disabled) minus.click();
    }
    root.querySelectorAll('[data-tier]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        wantQty = Number(r.value) || 1;
        if (qtyHidden) qtyHidden.value = wantQty;
        syncFormQty();
        updateWhatsapp();
      });
    });
    // Releasit renders late and redraws on variant change: keep its quantity in step
    if (root.querySelector('[data-tier]') && 'MutationObserver' in window) {
      var info = root.querySelector('.pdp__info') || root;
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; syncFormQty(); }, 150);
      }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    }

    // Releasit form: its text is typed in Arabic, so on /en and /fr pages
    // translate it and turn it left-to-right
    var i18nEl = root.querySelector('[data-rsi-i18n]');
    var i18n = {};
    try { i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {}; } catch (err) { i18n = {}; }
    var pageDir = document.documentElement.dir || 'rtl';
    var translating = false;
    function translateForm() {
      var box = document.getElementById('_rsi-form-container-embedded') || document.getElementById('es-form-container');
      if (!box || translating) return;
      translating = true;
      var form = box.querySelector('form');
      if (form && form.getAttribute('dir') !== pageDir) form.setAttribute('dir', pageDir);
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var raw = node.nodeValue;
        var text = raw.trim();
        if (!text) continue;
        if (i18n[text] !== undefined && i18n[text] !== text) {
          node.nodeValue = raw.replace(text, i18n[text]);
        } else {
          // the order button carries the total after the label: "اطلبي دابا - 269.00 dh"
          Object.keys(i18n).forEach(function (src) {
            if (src.length > 3 && text.indexOf(src) === 0 && text !== src && i18n[src] !== src) {
              node.nodeValue = raw.replace(src, i18n[src]);
            }
          });
        }
      }
      box.querySelectorAll('input[placeholder]').forEach(function (input) {
        var t = i18n[input.placeholder];
        if (t !== undefined && t !== input.placeholder) input.placeholder = t;
      });
      translating = false;
    }
    if (Object.keys(i18n).length && 'MutationObserver' in window) {
      var info2 = root.querySelector('.pdp__info') || root;
      var tPending = false;
      new MutationObserver(function () {
        if (tPending) return;
        tPending = true;
        setTimeout(function () { tPending = false; translateForm(); }, 60);
      }).observe(info2, { childList: true, subtree: true, characterData: true });
      translateForm();
    }

    // WhatsApp links carry the product, the chosen options and the quantity
    var waMain = root.querySelector('[data-wa]');
    function updateWhatsapp() {
      if (!waMain) return;
      var chosen = !root.classList.contains('needs-choice');
      var text = waMain.dataset.waMsg + ' ' + waMain.dataset.waTitle + (chosen ? ' - ' + current.title : '') +
        (wantQty > 1 ? ' × ' + wantQty : '') + ' - ' + waMain.dataset.waUrl + (chosen ? '?variant=' + current.id : '');
      var href = 'https://wa.me/' + waMain.dataset.wa + '?text=' + encodeURIComponent(text);
      root.querySelectorAll('[data-wa-link]').forEach(function (a) { a.href = href; });
    }
    radios.forEach(function (r) { r.addEventListener('change', updateWhatsapp); });
    updateWhatsapp();

    // the floating WhatsApp button sits above whichever sticky bottom bar is showing: the theme's own
    // and the order form app's (EasySell #es-sticky: added late, hidden with an inline display:none while the form is on screen)
    var waFloat = root.querySelector('.wa-float');
    if (waFloat) {
      var ownBar = root.querySelector('[data-sticky-buy]');
      var waBar = null;
      var liftWa = function () {
        var bar = document.getElementById('es-sticky');
        var lift = 0;
        if (bar && bar !== waBar) {
          waBar = bar;
          new MutationObserver(liftWa).observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
        }
        if (bar && getComputedStyle(bar).display !== 'none') {
          var r = bar.getBoundingClientRect();
          if (r.height && r.bottom >= window.innerHeight - 2) lift = Math.round(window.innerHeight - r.top);
        }
        if (ownBar && ownBar.classList.contains('is-visible') && getComputedStyle(ownBar).display !== 'none') lift = Math.max(lift, ownBar.offsetHeight);
        waFloat.style.setProperty('--wa-lift', lift + 'px');
      };
      if (ownBar) new MutationObserver(liftWa).observe(ownBar, { attributes: true, attributeFilter: ['class'] });
      liftWa();
      window.addEventListener('resize', liftWa);
      window.addEventListener('scroll', liftWa, { passive: true });
      new MutationObserver(liftWa).observe(document.body, { childList: true });
      [800, 2500, 5000].forEach(function (t) { setTimeout(liftWa, t); });
    }

    // the colour arrives pre-selected: name it, show its photos (the URL is left alone)
    if (root.querySelector('[data-option-index]:checked')) { onOptionChange(true); updateWhatsapp(); }

    // expected delivery dates: today + 3 to 5 days, written in the page's language
    var eta = root.querySelector('[data-eta]');
    var etaLine = eta && eta.querySelector('[data-eta-line]');
    if (etaLine && window.Intl && Intl.DateTimeFormat) {
      try {
        var lang = (document.documentElement.lang || 'ar').slice(0, 2);
        var loc = lang === 'ar' ? 'ar-MA-u-nu-latn' : lang === 'en' ? 'en-GB' : lang;
        var day = 864e5;
        var from = new Date(Date.now() + (Number(eta.dataset.etaMin) || 3) * day);
        var to = new Date(Date.now() + (Number(eta.dataset.etaMax) || 5) * day);
        var full = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long' });
        var fromText = from.getMonth() === to.getMonth() ? String(from.getDate()) : full.format(from);
        etaLine.textContent = eta.dataset.etaText.replace('{from}', fromText).replace('{to}', full.format(to));
        eta.hidden = false;
      } catch (err) {}
    }

    // sticky bar and the button under the landing images: jump to the order form
    root.querySelectorAll('[data-sticky-order], [data-landing-order]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('_rsi-form-container-embedded') || document.getElementById('es-form-container') || form;
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // sticky order bar on phones
    var sticky = root.querySelector('[data-sticky-buy]');
    if (sticky && form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top > 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          sticky.querySelectorAll('a').forEach(function (link) { link.tabIndex = show ? 0 : -1; });
        });
      });
      io.observe(form);
    }
  }

  // WhatsApp clicks → custom analytics event for the GA4 custom pixel (generate_lead); TikTok Contact is sent by snippets/tiktok-pixel.liquid
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"]');
    if (!a || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    var placement = a.classList.contains('wa-float') || a.classList.contains('btn--wa') ? 'product' : a.classList.contains('sticky-buy__wa') ? 'sticky' : 'site';
    Shopify.analytics.publish('whatsapp_click', { placement: placement, path: location.pathname });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-rotator]').forEach(initRotator);
    initDropdowns();
    initReveal();
    fitText();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitText, 120); });
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-slider]').forEach(initSlider);
  });

  /* ---------- Releasit order → thank-you page summary ----------
     Releasit publishes "releasit_checkout_completed" with the created order right before it redirects
     to /pages/merci; keep a short summary in sessionStorage for that page (sections/main-merci.liquid). */
  function saveOrder(order) {
    try {
      var addr = order.shipping_address || order.billing_address || {};
      var phone = String(addr.phone || order.phone || '').replace(/\s+/g, '');
      if (phone.indexOf('+212') === 0) phone = '0' + phone.slice(4);
      var slide = document.querySelector('.gallery__slide.is-active img');
      var image = slide ? (slide.currentSrc || slide.src) : '';
      var items = (order.line_items || []).map(function (li, i) {
        return { title: li.title, variant: li.variant_title || '', qty: li.quantity, image: i === 0 ? image : '' };
      });
      var shipping = (order.total_shipping_price_set && order.total_shipping_price_set.shop_money) ? order.total_shipping_price_set.shop_money.amount : 0;
      var total = (order.total_price_set && order.total_price_set.shop_money) ? order.total_price_set.shop_money.amount : order.total_price;
      // Order lines in TikTok's "contents" shape, for PlaceAnOrder on the thank-you page (snippets/tiktok-pixel.liquid)
      // Releasit's line items don't always carry product_id/price under the REST names, so try the other shapes;
      // whatever is still missing is filled from the product page by the pixel snippet.
      var lines = (order.line_items || []).map(function (li) {
        var id = li.product_id || li.productId || (li.product && li.product.id) || '';
        var priceSet = li.price_set && li.price_set.shop_money;
        var price = Number(li.price || (priceSet && priceSet.amount) || li.original_price || li.final_price) || 0;
        return { content_id: String(id).replace(/\D/g, ''), content_type: 'product', content_name: li.title || li.name || '', price: price, quantity: li.quantity || 1 };
      });
      sessionStorage.setItem('st_last_order', JSON.stringify({
        number: order.name || '', items: items, lines: lines, total: total, shipping: shipping, city: addr.city || '', phone: phone
      }));
    } catch (e) {}
  }
  function hookReleasit() {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function' || a.publish.__stHooked) return !!(a && a.publish && a.publish.__stHooked);
    var original = a.publish;
    a.publish = function (name, payload) {
      if (name === 'releasit_checkout_completed' && payload && payload.order) saveOrder(payload.order);
      return original.apply(this, arguments);
    };
    a.publish.__stHooked = true;
    return true;
  }
  /* Shopify swaps its analytics stub for the real publish() once the pixel manager is ready, which drops
     the wrapper — so re-check before every tap (the Releasit button is a tap) and after load. */
  hookReleasit();
  window.addEventListener('load', hookReleasit);

  /* EasySell hands the created order (same REST shape) to window.es_hook_purchase_success before it redirects.
     Chain onto whatever is already there (snippets/tiktok-pixel.liquid also listens on this hook). */
  (function () {
    var previous = window.es_hook_purchase_success;
    window.es_hook_purchase_success = function (order) {
      if (order) saveOrder(order);
      if (typeof previous === 'function') return previous.apply(this, arguments);
    };
  })();
  document.addEventListener('pointerdown', hookReleasit, true);
  document.addEventListener('click', hookReleasit, true);

  document.addEventListener('shopify:section:load', function (e) {
    fitText();
    initReveal();
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-rotator]').forEach(initRotator);
    e.target.querySelectorAll('[data-slider]').forEach(initSlider);
  });
})();
